//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState, mapGetters } from 'vuex';
import responsiveWindow from 'kolibri.coreVue.mixins.responsiveWindow';
import themeMixin from 'kolibri.coreVue.mixins.themeMixin';
import AppBar from 'kolibri.coreVue.components.AppBar';
import SideNav from 'kolibri.coreVue.components.SideNav';
import AuthMessage from 'kolibri.coreVue.components.AuthMessage';
import KLinearLoader from 'kolibri.coreVue.components.KLinearLoader';
import KPageContainer from 'kolibri.coreVue.components.KPageContainer';
import { throttle } from 'frame-throttle';
import Lockr from 'lockr';
import { UPDATE_MODAL_DISMISSED } from 'kolibri.coreVue.vuex.constants';
import { currentLanguage, defaultLanguage } from 'kolibri.utils.i18n';
import coreBannerContent from 'kolibri.utils.coreBannerContent';
import AppError from '../AppError';
import GlobalSnackbar from '../GlobalSnackbar';
import ImmersiveToolbar from '../ImmersiveToolbar';
import UpdateNotification from '../UpdateNotification';
import LanguageSwitcherModal from '../language-switcher/LanguageSwitcherModal';
import CoreBanner from '../CoreBanner';
import ScrollingHeader from './ScrollingHeader';

const scrollPositions = {
  _scrollPositions: {},
  getScrollPosition() {
    // Use key set by Vue Router on the history state.
    const key = (window.history.state || {}).key;
    const defaultPos = { x: 0, y: 0 };
    if (key && this._scrollPositions[key]) {
      return this._scrollPositions[key];
    }
    return defaultPos;
  },
  setScrollPosition({ x, y }) {
    const key = (window.history.state || {}).key;
    // Only set if we have a vue router key on the state,
    // otherwise we don't do anything.
    if (key) {
      this._scrollPositions[window.history.state.key] = { x, y };
    }
  },
};

export default {
  name: 'CoreBase',
  metaInfo() {
    return {
      // Use arrow function to bind $tr to this component
      titleTemplate: title => {
        if (this.error) {
          return this.$tr('kolibriTitleMessage', { title: this.$tr('errorPageTitle') });
        }
        if (!title) {
          // If no child component sets title, it reads 'Kolibri'
          return this.$tr('kolibriMessage');
        }
        // If child component sets title, it reads 'Child Title - Kolibri'
        return this.$tr('kolibriTitleMessage', { title });
      },
      title: this.pageTitle,
    };
  },
  components: {
    AppBar,
    AppError,
    CoreBanner,
    ImmersiveToolbar,
    SideNav,
    AuthMessage,
    GlobalSnackbar,
    KLinearLoader,
    KPageContainer,
    ScrollingHeader,
    UpdateNotification,
    LanguageSwitcherModal,
  },
  mixins: [responsiveWindow, themeMixin],
  props: {
    appBarTitle: {
      type: String,
      required: false,
      default: '',
    },
    // Prop that determines whether to show nav components and provide margins
    fullScreen: {
      type: Boolean,
      default: false,
    },
    // reserve space at the bottom for floating widgets
    marginBottom: {
      type: Number,
      default: 0,
    },
    // AUTHORIZATION SPECIFIC
    authorized: {
      type: Boolean,
      required: false,
      default: true,
    },
    authorizedRole: {
      type: String,
      required: false,
    },
    authorizationErrorHeader: {
      type: String,
      required: false,
    },
    authorizationErrorDetails: {
      type: String,
      required: false,
    },
    // IMMERSIVE-SPECIFIC
    immersivePage: {
      type: Boolean,
      required: false,
      default: false,
    },
    // generally a 'back' or 'close' icon
    immersivePageIcon: {
      type: String,
      required: false,
      default: 'close',
    },
    // link to where the 'back' button should go
    immersivePageRoute: {
      type: Object,
      required: false,
    },
    // determines the color, primary being the classic kolibri appbar color
    immersivePagePrimary: {
      type: Boolean,
      required: false,
    },
    toolbarTitle: {
      type: String,
      required: false,
      default: '',
    },
    // Alternative to using metaInfo in a top level component to set the
    // title of the HTML Document
    pageTitle: {
      type: String,
      required: false,
      default: '',
    },
    // If true, will render the component in the "sub-nav" slot and add 48px
    // to AppBody's top offset.
    showSubNav: {
      type: Boolean,
      default: false,
    },
    debug: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navShown: false,
      scrollPosition: 0,
      unwatchScrollHeight: undefined,
      notificationModalShown: true,
      languageModalShown: false,
    };
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSuperuser', 'demoBannerVisible']),
    ...mapState({
      error: state => state.core.error,
      loading: state => state.core.loading,
      blockDoubleClicks: state => state.core.blockDoubleClicks,
      busy: state => state.core.signInBusy,
      notifications: state => state.core.notifications,
    }),
    headerHeight() {
      return this.windowIsSmall ? 56 : 64;
    },
    appbarHeight() {
      if (this.showSubNav) {
        // Adds the height of KNavBar
        return this.headerHeight + 48;
      }
      return this.headerHeight;
    },
    navWidth() {
      return this.headerHeight * 4;
    },
    notAuthorized() {
      // catch "not authorized" error, display AuthMessage
      if (this.error && this.error.status && this.error.status.code == 403) {
        return true;
      }
      return !this.authorized;
    },
    mainWrapperStyles() {
      if (this.fullScreen) {
        return { top: 0, bottom: 0 };
      }
      return {
        top: this.fixedAppBar ? `${this.appbarHeight}px` : 0,
        bottom: `${this.marginBottom}px`,
        backgroundColor: this.$themeColors.palette.grey.v_100,
      };
    },
    contentStyles() {
      if (this.fullScreen) {
        return {
          marginTop: '0px',
          marginBottom: '0px',
          padding: '0px',
        };
      }
      return {
        marginTop: `${this.fixedAppBar ? 0 : this.appbarHeight}px`,
        padding: `${this.windowIsSmall ? 16 : 32}px`,
      };
    },
    fixedAppBar() {
      return this.windowIsLarge && !this.windowIsShort;
    },
    // calls handleScroll no more than every 17ms
    throttledHandleScroll() {
      return throttle(this.handleScroll);
    },
    showNotification() {
      if (
        (this.isAdmin || this.isSuperuser) &&
        !Lockr.get(UPDATE_MODAL_DISMISSED) &&
        this.notificationModalShown &&
        this.notifications.length !== 0
      ) {
        return true;
      }
      return false;
    },
    mostRecentNotification() {
      let languageCode = defaultLanguage.id;
      // notifications should already be ordered by timestamp
      const notification = this.notifications[0];
      // check if translated message is available for current language
      if (notification.i18n[currentLanguage] !== undefined) {
        languageCode = currentLanguage;
      }
      // i18n data structure generated by nutritionfacts_i18n.py
      return {
        id: notification.id,
        title: notification.i18n[languageCode].title,
        msg: notification.i18n[languageCode].msg,
        linkText: notification.i18n[languageCode].link_text,
        linkUrl: notification.link_url,
      };
    },
    contentComponentName() {
      return this.$slots.default[0].context.$options.name;
    },
    routePath() {
      if (this.$router.getRouteDefinition(this.contentComponentName)) {
        return this.$router.getRouteDefinition(this.contentComponentName).path;
      }
      return '';
    },
    coreBannerComponent() {
      return coreBannerContent[0];
    },
  },
  watch: {
    $route() {
      // Set a watcher so that if the router sets a new
      // route, we update our scroll position based on the ones
      // we have tracked in the scrollPosition object above.
      if (this.unwatchScrollHeight) {
        this.unwatchScrollHeight();
      }
      if (this.loading) {
        // Don't set scroll position until the main content
        // of coreBase is shown in the DOM.
        // Create a watcher to monitor changes in loading
        // to try to set the scrollHeight after the contents
        // have loaded.
        this.unwatchScrollHeight = this.$watch('loading', () => {
          this.unwatchScrollHeight();
          this.$nextTick(() => {
            // Set the scroll in next tick for safety, to ensure
            // that the child components have finished mounting
            this.setScroll();
          });
        });
      } else {
        this.setScroll();
      }
    },
  },
  beforeRouteUpdate() {
    this.recordScroll();
  },
  beforeRouteLeave() {
    this.recordScroll();
  },
  mounted() {
    this.setScroll();
  },
  methods: {
    handleScroll() {
      this.scrollPosition = this.$el.scrollTop;
      this.recordScroll();
    },
    recordScroll() {
      scrollPositions.setScrollPosition({ y: this.$el.scrollTop });
    },
    dismissUpdateModal() {
      if (this.notifications.length === 0) {
        this.notificationModalShown = false;
        Lockr.set(UPDATE_MODAL_DISMISSED, true);
      }
    },
    setScroll() {
      this.$el.scrollTop = scrollPositions.getScrollPosition().y;
      this.scrollPosition = this.$el.scrollTop;
    },
  },
  $trs: {
    kolibriMessage: 'Kolibri',
    kolibriTitleMessage: '{ title } - Kolibri',
    errorPageTitle: 'Error',
  },
};

